// Generated by Claude Code
import { VendorDetailPanel } from '#components/domain/operations/vendors/detail/vendor-detail-panel.tsx'
import { PermissionGuard } from '#components/tools/permission-guard.tsx'
import { PermissionService } from '#core/entities/auth/roles/Permission.ts'
import { readAnyGroups } from '#core/entities/auth/roles/permission-gate-helpers.ts'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_app/$companyId/vendors/$vendorId')({
  component: RouteComponent,
  staticData: {
    title: 'Vendor Detail',
  },
})

function RouteComponent() {
  return (
    <PermissionGuard permissions={readAnyGroups(PermissionService.VENDORS)} redirectOnNotAuthorized>
      <VendorDetailPageContent />
    </PermissionGuard>
  )
}

function VendorDetailPageContent() {
  const { companyId, vendorId } = Route.useParams()
  const navigate = useNavigate()
  const { t } = useTranslation('vendors')

  function handleBack() {
    void navigate({ to: '/$companyId/vendors', params: { companyId } })
  }

  return (
    <div className="container-fluid d-flex flex-column h-100 py-3">
      <div className="row justify-content-center flex-grow-1">
        <div className="col-12 col-lg-10 col-xl-8 d-flex flex-column">
          <div className="mb-2">
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
              onClick={handleBack}
            >
              <ArrowLeft size={14} />
              {t('shared.actions.backToList')}
            </button>
          </div>
          <div className="flex-grow-1 overflow-hidden card rounded-3 p-0">
            <VendorDetailPanel vendorId={vendorId} onClose={handleBack} onDeleted={handleBack} />
          </div>
        </div>
      </div>
    </div>
  )
}
